import $ from 'jquery';

export default function () {
    const filterField = $('.js-filter-and-sort');
    if (!filterField.length) {
        return;
    }

    const field = filterField.attr('name');

    filterField.on('change', function () {
        document.location.href = $(this).val();
    })

    // if (document.location.href.includes(field + '=') && $(".js-filtered-list").length) {
    //     $('html, body').animate({
    //         scrollTop: $(".js-filtered-list").offset().top - 92
    //     }, 2);
    // }
}
